var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "countdown-settings-modal",
      attrs: {
        visible: _vm.visible,
        title: "Geri Sayım Ayarları - " + _vm.widget.title,
        width: "600px",
        footer: null,
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "a-form",
        { attrs: { form: _vm.form, layout: "vertical" } },
        [
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("table.targetDateAndTime") } },
            [
              _c(
                "div",
                { staticClass: "date-time-inputs" },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      value: _vm.$moment(_vm.previewSettings.targetDate),
                      format: "DD.MM.YYYY",
                    },
                    on: {
                      change: function (date) {
                        return _vm.handleDateChange(date)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("a-time-picker", {
                    staticStyle: { width: "100px" },
                    attrs: {
                      value: _vm.$moment(_vm.previewSettings.targetDate),
                      format: "HH:mm",
                    },
                    on: {
                      change: function (time) {
                        return _vm.handleTimeChange(time)
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("table.unitsToDisplay") } },
            [
              _c(
                "div",
                { staticClass: "units-grid" },
                [
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.showUnits.months,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings.showUnits, "months", $$v)
                        },
                        expression: "previewSettings.showUnits.months",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.months")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.showUnits.weeks,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings.showUnits, "weeks", $$v)
                        },
                        expression: "previewSettings.showUnits.weeks",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.weeks")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.showUnits.days,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings.showUnits, "days", $$v)
                        },
                        expression: "previewSettings.showUnits.days",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.days")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.showUnits.hours,
                        callback: function ($$v) {
                          _vm.$set(_vm.previewSettings.showUnits, "hours", $$v)
                        },
                        expression: "previewSettings.showUnits.hours",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.hours")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.showUnits.minutes,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.previewSettings.showUnits,
                            "minutes",
                            $$v
                          )
                        },
                        expression: "previewSettings.showUnits.minutes",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.minutes")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.previewSettings.showUnits.seconds,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.previewSettings.showUnits,
                            "seconds",
                            $$v
                          )
                        },
                        expression: "previewSettings.showUnits.seconds",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("table.seconds")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-collapse",
            [
              _c(
                "a-collapse-panel",
                { key: "1", attrs: { header: _vm.$t("table.styleSettings") } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("table.backgroundColor") } },
                    [
                      _c("a-input", {
                        attrs: { type: "color" },
                        model: {
                          value: _vm.previewSettings.style.backgroundColor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.previewSettings.style,
                              "backgroundColor",
                              $$v
                            )
                          },
                          expression: "previewSettings.style.backgroundColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("table.textColor") } },
                    [
                      _c("a-input", {
                        attrs: { type: "color" },
                        model: {
                          value: _vm.previewSettings.style.textColor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.previewSettings.style,
                              "textColor",
                              $$v
                            )
                          },
                          expression: "previewSettings.style.textColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("table.numberSize") } },
                    [
                      _c("a-slider", {
                        attrs: { min: 16, max: 96, step: 4 },
                        model: {
                          value: _vm.previewSettings.style.fontSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.previewSettings.style, "fontSize", $$v)
                          },
                          expression: "previewSettings.style.fontSize",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("table.labelSize") } },
                    [
                      _c("a-slider", {
                        attrs: { min: 12, max: 32, step: 2 },
                        model: {
                          value: _vm.previewSettings.style.labelFontSize,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.previewSettings.style,
                              "labelFontSize",
                              $$v
                            )
                          },
                          expression: "previewSettings.style.labelFontSize",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            {
              staticClass: "preview-section",
              attrs: { label: _vm.$t("table.preview") },
            },
            [
              _c(
                "div",
                {
                  staticClass: "preview-container",
                  style: {
                    backgroundColor: _vm.previewSettings.style.backgroundColor,
                    color: _vm.previewSettings.style.textColor,
                    padding: "24px",
                  },
                },
                [
                  _c("div", { staticClass: "countdown-preview" }, [
                    _vm.previewSettings.showUnits.months
                      ? _c(
                          "div",
                          {
                            staticClass: "countdown-unit",
                            style: {
                              fontSize:
                                _vm.previewSettings.style.fontSize + "px",
                            },
                          },
                          [
                            _c("div", { staticClass: "value" }, [_vm._v("5")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                style: {
                                  fontSize:
                                    _vm.previewSettings.style.labelFontSize +
                                    "px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("table.months")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.previewSettings.showUnits.weeks
                      ? _c(
                          "div",
                          {
                            staticClass: "countdown-unit",
                            style: {
                              fontSize:
                                _vm.previewSettings.style.fontSize + "px",
                            },
                          },
                          [
                            _c("div", { staticClass: "value" }, [_vm._v("2")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                style: {
                                  fontSize:
                                    _vm.previewSettings.style.labelFontSize +
                                    "px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("table.weeks")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.previewSettings.showUnits.days
                      ? _c(
                          "div",
                          {
                            staticClass: "countdown-unit",
                            style: {
                              fontSize:
                                _vm.previewSettings.style.fontSize + "px",
                            },
                          },
                          [
                            _c("div", { staticClass: "value" }, [_vm._v("15")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                style: {
                                  fontSize:
                                    _vm.previewSettings.style.labelFontSize +
                                    "px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("table.days")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.previewSettings.showUnits.hours
                      ? _c(
                          "div",
                          {
                            staticClass: "countdown-unit",
                            style: {
                              fontSize:
                                _vm.previewSettings.style.fontSize + "px",
                            },
                          },
                          [
                            _c("div", { staticClass: "value" }, [_vm._v("23")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                style: {
                                  fontSize:
                                    _vm.previewSettings.style.labelFontSize +
                                    "px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("table.hours")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.previewSettings.showUnits.minutes
                      ? _c(
                          "div",
                          {
                            staticClass: "countdown-unit",
                            style: {
                              fontSize:
                                _vm.previewSettings.style.fontSize + "px",
                            },
                          },
                          [
                            _c("div", { staticClass: "value" }, [_vm._v("45")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                style: {
                                  fontSize:
                                    _vm.previewSettings.style.labelFontSize +
                                    "px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("table.minutes")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.previewSettings.showUnits.seconds
                      ? _c(
                          "div",
                          {
                            staticClass: "countdown-unit",
                            style: {
                              fontSize:
                                _vm.previewSettings.style.fontSize + "px",
                            },
                          },
                          [
                            _c("div", { staticClass: "value" }, [_vm._v("30")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "label",
                                style: {
                                  fontSize:
                                    _vm.previewSettings.style.labelFontSize +
                                    "px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("table.seconds")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("table.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.handleSave },
                },
                [_vm._v(_vm._s(_vm.$t("table.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }